import React from 'react'
import { KelmanSlider } from '@phaco3d/kelman'
import { makeStyles } from '@material-ui/core'
import { useSlider } from '../../providers/SliderSimulation'
import ScenariosButton from '../Scenarios/ScenariosButton'

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    position: 'relative',
    '& > div:nth-of-type(1)': {
      height: '100% !important',
      maxWidth: '100%',
      maxHeight: '100vh',
      position: 'absolute'
    }
  }
}))

const Slider: React.FC = () => {
  const classes = useStyles()
  const { configLeft, configRight, imageUrl, setImageUrl } = useSlider()
  const handleChange = (url: string) => {
    if (setImageUrl) {
      setImageUrl(url)
    }
  }

  return (
    <div className={classes.root}>
      {configLeft && configRight && imageUrl && (
        <KelmanSlider
          leftImage={imageUrl}
          rightImage={imageUrl}
          rightBrightness={configRight.brightness}
          rightContrast={configRight.contrast}
          rightGrayscale={configRight.grayscale}
          rightInvert={configRight.invert}
          rightOpacity={configRight.opacity}
          rightSaturate={configRight.saturate}
          rightSepia={configRight.sepia}
          rightBlur={configRight.blur}
          leftBrightness={configLeft.brightness}
          leftContrast={configLeft.contrast}
          leftGrayscale={configLeft.grayscale}
          leftInvert={configLeft.invert}
          leftOpacity={configLeft.opacity}
          leftSaturate={configLeft.saturate}
          leftSepia={configLeft.sepia}
          leftBlur={configLeft.blur}
        />
      )}
      {setImageUrl && <ScenariosButton handleScenarioChange={handleChange} />}
    </div>
  )
}

export default Slider
